import Enumerable from "linq";
import { TreeNode } from ".";

export class Directory<TKey, TEntity> extends TreeNode<Directory<TKey, TEntity>> {
  /**
   * sortはWEB版フォーマット編集で使う場合がある模様
   */
  constructor(public key: TKey, public name: string, directories: Directory<TKey, TEntity>[], public entities: TEntity[], public sort?: number, public recordId?: number) {
    super(directories);
  }

  clone(cloneKey: (source: TKey) => TKey = null, cloneEntity: (source: TEntity) => TEntity = null): Directory<TKey, TEntity> {
    return new Directory<TKey, TEntity>(
      !cloneKey ? this.cloneInstance<TKey>(this.key) : cloneKey(this.key),
      this.name,
      Enumerable.from(this.nodes).select(d => d.clone(cloneKey, cloneEntity)).toArray(),
      Enumerable.from(this.entities).select(e => !cloneEntity ? this.cloneInstance<TEntity>(e) : cloneEntity(e)).toArray(),
      this.sort,
      this.recordId
    );
  }

  private cloneInstance<T>(source: T): T {
    return this.cloneAnyInstance(source) as T;
  }

  private cloneAnyInstance(source: any): any {
    return (source && source.clone !== undefined)
      ? source.clone()
      : source;
  }
}
